import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../shared/components/Modal';
import { withTranslation } from "react-i18next";

class WelcomeModal extends Component {
    static propTypes = {
        isOpen: PropTypes.bool,
        onAccept: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired
    };

    render() {
        const {t} = this.props;
        return (
            <CustomModal
                isOpen={this.props.isOpen}
                onAccept={this.props.onAccept}
                onClose={this.props.onClose}
                color="primary"
                title={t('modals.welcome.title')}
                colored
                cancelButtonText={t('modals.welcome.buttons.cancel')}
                okButtonText={t('modals.welcome.buttons.ok')}
                message={t('modals.welcome.body')}
            />
        );
    }
}

export default withTranslation('dashboard')(WelcomeModal);
